import { default as giftcard, namespace as giftcardNamespace } from './modules/giftcard'
import createPersistedState from 'vuex-persistedstate'

const namespaced = true
const namespace = 'Giftcards'

const modules = {
  [giftcardNamespace]: giftcard,
}

const state = {}

const mutations = {}

const actions = {}

const getters = {}

const plugins = [
  createPersistedState({
    paths: [
      `${namespace}.${giftcardNamespace}.editItem`,
      `${namespace}.${giftcardNamespace}.cartItems`,
    ],
    key: namespace,
  }),
]

export { namespaced, namespace, state, mutations, actions, getters, plugins, modules }
